

















































































































import { Button, Popover, Tooltip } from 'element-ui'
import { Vue, Component, Prop } from 'vue-property-decorator'

import RoundAvatar from '@/components/RoundAvatar.vue'
import StatusLabel from '@/components/StatusLabel.vue'

import Booking from '@/models/booking'
import Currency from '@/models/currency'
import Passenger, {
  PassengerStatuses,
  PassengerInfoStatuses,
  TransportSuboptions,
} from '@/models/passenger'
import { PassengerExtraValueTypes } from '@/models/passenger-extra'

import { toCurrency } from '@/globalMixin'

import PassengerPriceBreakdown from './PassengerPriceBreakdown.vue'

@Component({
  components: {
    RoundAvatar,
    StatusLabel,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    PassengerPriceBreakdown,
  },
})
export default class BookingPassengerBlock extends Vue {
  @Prop() passenger!: Passenger
  @Prop() isLead!: boolean
  @Prop() currentCustomerIsLead!: boolean
  @Prop() isPassengerGuest!: boolean
  @Prop() paymentAllocationEnabled!: boolean
  @Prop() booking!: Booking
  @Prop(String) currencyCode!: Currency

  isFolded = true
  isPassengerTooltipHovered = false
  passengerExtraValueTypes = PassengerExtraValueTypes

  get passengerNameField(): string {
    const { noName, passenger, currentCustomerIsLead } = this

    if (!noName) {
      return this.passenger.fullName
    } else if (passenger.customerId) {
      return 'Invited Passenger'
    } else if (currentCustomerIsLead) {
      return 'Add Name'
    }

    return 'Passenger'
  }

  get passengerCancelled(): boolean {
    return this.passenger.passengerStatus === PassengerStatuses.Cancelled
  }

  get isDefaultDeck(): boolean {
    return this.passenger.deck === TransportSuboptions.Default
  }

  get passengerIconClass(): string | null {
    if (this.passenger.fullName.trim().length > 0) {
      return null
    }
    if (
      this.passenger.customerId ||
      this.passenger.personalInfoStatus === PassengerInfoStatuses.Complete
    ) {
      return 'sc-icon-person'
    }

    return this.currentCustomerIsLead ? 'sc-icon-add' : 'sc-icon-person'
  }

  get unassignedPassengerTooltipVisible(): boolean {
    return (
      !this.passenger.fullName &&
      this.isPassengerTooltipHovered &&
      !this.currentCustomerIsLead
    )
  }

  get noName(): boolean {
    return this.passenger.fullName.trim().length === 0
  }

  get passengerStatuses() {
    return PassengerStatuses
  }

  get isPassengerPriceHidden(): boolean {
    // Temporarily disabled
    return false
  }

  get passengerDisplayedTotal() {
    const { passenger, passengerCancelled, currencyCode } = this

    return toCurrency(
      passengerCancelled
        ? passenger.cancellationFeeCents
        : passenger.totalPriceCents,
      currencyCode,
    )
  }

  onClickFoldButton(e: Event) {
    if (this.isPassengerPriceHidden) {
      return
    }

    e.stopPropagation()
    this.isFolded = !this.isFolded
  }

  onClickPassenger() {
    this.$emit('on-edit-passenger')
    this.isPassengerTooltipHovered = true
  }
}
